import {Switch, useRouteMatch} from "react-router-dom";

import '../../assets/styles/events/conferencesList.scss';
import '../../assets/styles/events/conferenceList/conferenceListPage.scss';

import AllEvents from "./All";
import FavoriteEvents from "./Favorite";
import GuardedRoute from "../../components/Route/GuardedRoute";

export default function EventsPage() {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <GuardedRoute
                exact
                path={path}
            >
                <AllEvents />
            </GuardedRoute>
            <GuardedRoute
                exact
                path={`${path}/favorite`}
                authRequired
            >
                <FavoriteEvents />
            </GuardedRoute>
        </Switch>
    );
}
